export default __webpack_public_path__ + "static/media/alert.6b0930cb.svg";